import moment from "moment-timezone";

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const Timezone = moment.tz.guess();

export const toUTC = (dateString, timeZone = userTimeZone) => {
  return moment.tz(dateString, timeZone).utc().toDate();
};

export const toLocal = (utcDate, format, timeZone = userTimeZone) => {
  let date = moment.utc(utcDate).tz(timeZone);
  if (format) {
    return date.format(format);
  }
  return date;
};
